import { constantTree } from "../../../core/events/ConstantTree";

export const journeyPlannerTree = constantTree({
  popup: {
    init: ""
  },
  location: {
    click: ""
  },
  journey: {
    tab: {
      change: ""
    },
    search: "",
    confirm: ""
  }
})
  